import React from 'react';
import oasisIcon from './assets/oasis-icon.png';
import { useOpenApp } from './hooks';

export const Wave = ({ color = 'rgba(255,255,255,0.92)', size = 72 }: { color?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 72 72" fill="none">
    <g stroke={color} strokeWidth="5.5" strokeLinecap="round">
      <path d="M10 36v0" />
      <path d="M22 28v16" />
      <path d="M34 18v36" />
      <path d="M46 22v28" />
      <path d="M58 30v12" />
    </g>
  </svg>
);

export function OasisIcon({ size = 30, shape = 'squircle' }: { size?: number; shape?: 'squircle' | 'circle' }) {
  return (
    <img
      src={oasisIcon}
      alt="Oasis"
      style={{
        width: size,
        height: size,
        borderRadius: shape === 'circle' ? '50%' : Math.max(4, size * 0.25),
        display: 'block',
        objectFit: 'cover',
        boxShadow: '0 4px 10px rgba(15,20,40,0.20)',
        flexShrink: 0,
      }}
    />
  );
}

export function BrandMark() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <OasisIcon size={30} shape="squircle" />
      <span
        style={{
          fontFamily: '"Cal Sans", system-ui',
          fontWeight: 700,
          fontSize: 17,
          color: 'inherit',
          letterSpacing: 0.1,
        }}
      >
        Oasis
      </span>
    </div>
  );
}

export function OpenInAppPill({ dark, compact, videoId }: { dark?: boolean; compact?: boolean; videoId?: string }) {
  const openApp = useOpenApp(videoId);
  return (
    <button
      onClick={openApp}
      style={{
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: compact ? '6px 6px 6px 12px' : '8px 8px 8px 14px',
        height: compact ? 36 : 40,
        borderRadius: 9999,
        background: dark ? 'rgba(255,255,255,0.10)' : '#1A1815',
        border: dark ? '1px solid rgba(255,255,255,0.18)' : 'none',
        color: '#fff',
        whiteSpace: 'nowrap',
        fontSize: 12.5,
        fontWeight: 600,
        boxShadow: dark ? 'none' : '0 6px 16px rgba(26,24,21,0.20)',
      }}
    >
      <span>Open in App</span>
      <OasisIcon size={compact ? 24 : 28} shape="circle" />
    </button>
  );
}
